import { useNavigate } from 'react-router-dom';
import {
  useCheckExistenceMutation,
  useCreateChatRoomMutation,
} from '~/features/chatRoom';
import { CheckChatRoomExistenceRequest, Chat01RoomType } from '~/types';
import { PAGE_ROUTE } from '~/constants';
import { useUserStore } from '~/store';
import useChatPageLoadingStatus from '~/store/useChatPageLoadingStatusStore';
import useToast from '~/store/useToast';
import { CreateChatRoomRequest } from './../types/chatRoomApi';

const useMoveChatRoom = ({
  chatRoomLoadingBg,
}: {
  chatRoomLoadingBg: string;
}) => {
  const navigate = useNavigate();
  const { language } = useUserStore((state) => ({
    language: state.language,
  }));

  const { showToast } = useToast();

  const { mutate: existenceMutate, isPending: isExistencePending } =
    useCheckExistenceMutation();
  const { mutate: createMutate, isPending: isCreatePending } =
    useCreateChatRoomMutation();

  const { setChatPageLoadingStart, isChatPageLoading } =
    useChatPageLoadingStatus();

  const handleChatPageLoadingStart = () => {
    if (!isChatPageLoading && chatRoomLoadingBg) {
      setChatPageLoadingStart(chatRoomLoadingBg);
    }
  };

  const handleCreateRoomClick = async (
    character_id: CreateChatRoomRequest['character_id'],
    type: Chat01RoomType,
  ) => {
    const request: CheckChatRoomExistenceRequest = {
      character_id,
    };
    existenceMutate(request, {
      onSuccess: ({ data, status }) => {
        const { is_existence, chatroom_id } = data;

        if (is_existence) {
          handleChatPageLoadingStart();

          if (type === 'mystery') {
            navigate(`${PAGE_ROUTE.MYSTERY}/${chatroom_id}`);
          } else {
            navigate(`${PAGE_ROUTE.CHAT}/${chatroom_id}`);
          }
        } else {
          const requestData: CreateChatRoomRequest = {
            character_id,
            language,
          };
          createMutate(requestData, {
            onSuccess: ({ data, status }, request) => {
              handleChatPageLoadingStart();

              if (type === 'mystery') {
                navigate(`${PAGE_ROUTE.MYSTERY}/${data.chatroom_id}`);
              } else if (type === 'concept') {
                navigate(`${PAGE_ROUTE.CHAT_CONCEPT}/${data.chatroom_id}`);
              } else {
                navigate(`${PAGE_ROUTE.CHAT}/${data.chatroom_id}`);
              }
            },
          });
        }
      },
    });
  };

  return {
    handleCreateRoomClick,
    isCreateRoomPending: isExistencePending || isCreatePending,
  };
};

export default useMoveChatRoom;
